import { __awaiter } from "tslib";
import { createStore } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import Api from '@/services';
import { notification } from 'antd';
const { order } = Api;
const initState = {
    tableTotal: 0,
    pageSize: 20,
    pageIndex: 1,
    TableData: [],
    sourceNameList: [],
    argueTypeList: [],
    loading: false,
};
const argueModal = {
    visible: false,
    editData: {},
};
export default createStore({
    state: Object.assign(Object.assign(Object.assign({}, initState), argueModal), { searchData: {
            sourceCode: '',
        } }),
    effects: {
        updateTable({ page }, { state }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { searchData, pageIndex, pageSize } = state;
                const searchParams = Object.assign(Object.assign({}, searchData), { pageIndex: page || pageIndex, pageSize });
                this.SET_STATE({
                    loading: true,
                });
                console.log('搜索参数', searchParams);
                order.findByPage(searchParams).then((res) => {
                    console.log(res);
                    const { items, totalNumber } = res;
                    this.SET_STATE({
                        TableData: items,
                        tableTotal: totalNumber,
                        pageIndex: page || pageIndex,
                    });
                }).finally(() => {
                    this.SET_STATE({
                        loading: false,
                    });
                });
            });
        },
        // desc 重置数据
        resetState(params) {
            this.SET_STATE(Object.assign({}, initState));
        },
        // 修改争议子类型设置
        editArgueCharge({ data, callback }, { state }) {
            const { editData = {} } = state;
            const { id = '' } = editData;
            const params = Object.assign(Object.assign({}, data), { id });
            order.saveDisputeType(params).then((res) => {
                const msg = '';
                callback && callback(res, msg);
            });
        },
        // 删除争议子类型数据
        deleteRow(rowData) {
            const { id } = rowData;
            order.deleteById({ id }).then((res) => {
                // console.log(res)
                if (res) {
                    notification.success({
                        message: '删除成功',
                    });
                    dispatch.argueDetail.updateTable({});
                }
            }).catch(() => {
                notification.error({
                    message: '删除失败，请重试',
                });
            });
        },
        getSourceName() {
            order.getDisputeSources().then((res) => {
                console.log(res);
                dispatch.argueDetail.SET_STATE({
                    sourceNameList: res,
                });
            }).catch(() => {
                notification.error({
                    message: '争议发起方搜索失败，请重试',
                });
            });
        },
        getArgueType(params, { state }) {
            // console.log(params);
            order.getTypesBySourceCoce({ sourceCode: params.sourceCode }).then((res) => {
                console.log(res);
                dispatch.argueDetail.SET_STATE({
                    argueTypeList: res,
                });
            }).catch(() => {
                notification.error({
                    message: '争议类型获取失败，请重试',
                });
            });
        },
    },
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
        // 隐藏模态框
        HIDE_ARGUE_EDIT(state) {
            state.visible = false;
        },
        // 显示模态框
        SHOW_ARGUE_EDIT(state, data) {
            state.visible = true;
            state.editData = data;
        },
    },
});
